// Single source of truth for brand name, company data and contacts.
// Update here when the brand changes (see rebranding to Banca Sistema).
const brand = {
  name: "Banca Sistema",
  legalName: "BANCA SISTEMA S.P.A.",
  address: "Largo Augusto 1/A, ang. via Verziere 13, 20122 Milano (MI)",
  vatNumber: "12870770158",
  websiteUrl: "https://www.bancacfplus.it",
  staticUrl: "https://static.bancacfplus.it",
  supportEmail: "customer.banking@bancasistema.it",
  supportPhone: "800 938 874",
  supportPhoneHref: "tel:+39800938874"
} as const

export { brand }
